import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/Dialog';
import { useLanguage } from '../../localization/useLanguage';
import { getSiteDomain } from '../../Helpers/Utility';
import logger from '../../Helpers/logger';
import { IconCopy } from '../../Components/Common/Icons';
import styles from './InviteDialog.module.scss';

const INVITE_PATH = 'invite';
const COPIED_FEEDBACK_MS = 2000;

// REACT_APP_SITE_DOMAIN is configured with a trailing slash on some environments and
// without it on others, so the separator is normalised rather than assumed.
const getInviteLink = () => `${getSiteDomain().replace(/\/+$/, '')}/${INVITE_PATH}`;

/**
 * Invite to Dazway pop-up (FR59 screen 59.4).
 *
 * @param open Whether the dialog is visible.
 * @param onOpenChange Called when the dialog wants to close.
 */
export default function InviteDialog({ open, onOpenChange }) {
    const { t } = useLanguage();
    const [copied, setCopied] = useState(false);

    const invitation = `${t('chat.invite.MESSAGE')} ${getInviteLink()}`;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(invitation);
            setCopied(true);
            setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
        } catch (error) {
            // Clipboard access is denied outside a secure context, so the user copies by hand.
            logger.warn('Failed to copy the invitation link:', error);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className={styles.dialog}>
                <DialogHeader>
                    <DialogTitle>{t('chat.invite.TITLE')}</DialogTitle>
                </DialogHeader>

                <div className={styles.field}>
                    {/* Read-only by spec: the invitation wording and link are fixed. */}
                    <textarea
                        className={styles.input}
                        value={invitation}
                        readOnly
                        rows={3}
                        aria-label={t('chat.invite.TITLE')}
                    />
                    <button
                        type="button"
                        className={styles.copy}
                        onClick={handleCopy}
                        aria-label={t('chat.invite.COPY')}
                        title={t('chat.invite.COPY')}
                    >
                        <IconCopy />
                    </button>
                </div>

                {copied && <p className={styles.copied}>{t('chat.invite.COPIED')}</p>}
            </DialogContent>
        </Dialog>
    );
}
